var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeople = function SvgPeople(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.443 10.832a6 6 0 1 1 7.114 0A8 8 0 0 1 30 18h-2a6 6 0 1 0-12 0c0 1.982-.961 3.74-2.443 4.832A8 8 0 0 1 18 30h-2a6 6 0 1 0-12 0H2a8 8 0 0 1 4.443-7.168 6 6 0 1 1 8.39-8.39 8.034 8.034 0 0 1 3.61-3.61zM10 22a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm12-12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    fill: "#000"
  })));
};
export default SvgPeople;